import React from 'react';
import stylesInput from './input.module.css';

import { getDefinedValue, getDefinedItem } from '../../util/tools';

class Label extends React.Component {
	/*
		title
		tooltip
		styles
			divMain
	*/
	constructor(props) {
		super(props);
	}

	render() {
		
		let title = getDefinedValue(this.props.title, 'LABEL');
		let tooltip = this.props.tooltip;
		
		let divMainStyle = Object.assign({}, {color: 'darkBlue', fontStyle: 'italic'}, getDefinedItem(this.props, ['styles', 'divMain']));

		if( tooltip )
			return (
				<div className={stylesInput.divLabelWithTooltip} style={divMainStyle}>
					{title} 
					<span className={stylesInput.tooltiptext}>{tooltip}</span>
				</div>
			);
		else {
			return (
				<div style={divMainStyle}>
					{title} 
				</div>
			);
		}
	}
}

export default Label;